'use client'

import { ErrorFallback, useRouteErrorReport } from '@/components/error-boundary'

/**
 * Route boundary for /upload. It renders inside the root layout, so a failure
 * in the upload widget (the queue cards, the teaser form) costs the visitor
 * that widget instead of the whole document — before this existed the root
 * boundary caught it and replaced the page, header and all.
 */
export default function UploadError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useRouteErrorReport(error, 'route-error')

  return (
    <ErrorFallback
      error={error}
      onRetry={reset}
      description="The upload page hit an error. Trying again usually fixes it."
    />
  )
}
